import React, { useState } from 'react';
import { Calculator, ShoppingBag, MessageCircle, ChevronLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { getCustomMasaKartiUnitPrice } from './BaskiPage';

const CalculatorPage = () => {
  const navigate = useNavigate();
  const [tableCards, setTableCards] = useState(50);
  const [handCards, setHandCards] = useState(50);
  const [boardCards, setBoardCards] = useState(0);
  const [aiEnhance, setAiEnhance] = useState(0);
  const [aiArtistic, setAiArtistic] = useState(0);

  const handCardPrice = 5;
  const boardPrice = 900;
  const aiEnhancePrice = 1; // Yapay Zeka İyileştirme birim fiyatı (TL)
  const aiArtisticPrice = 5; // Yapay Zeka Sanatsal Filtre birim fiyatı (TL)
  const baseFee = 1600;

  const tableCardTotal = tableCards > 0 ? Math.round(tableCards * getCustomMasaKartiUnitPrice(tableCards)) : 0;
  const handCardTotal = handCards * handCardPrice;
  const boardTotal = boardCards * boardPrice;
  const aiEnhanceTotal = aiEnhance * aiEnhancePrice;
  const aiArtisticTotal = aiArtistic * aiArtisticPrice;
  const total = tableCardTotal + handCardTotal + boardTotal + aiEnhanceTotal + aiArtisticTotal + baseFee;

  const handleWhatsapp = () => {
    let message = `Merhaba, ${tableCards} Masa Kartı, ${handCards} El Kartı, ${boardCards} Karşılama Panosu`;
    if (aiEnhance > 0) message += `, ${aiEnhance} AI İyileştirme`;
    if (aiArtistic > 0) message += `, ${aiArtistic} AI Sanatsal Filtre`;
    message += ` (Kişiye Özel Paket, Toplam: ${total} TL) için detaylı bilgi almak istiyorum.`;
    window.open(`https://wa.me/905546983144?text=${encodeURIComponent(message)}`, '_blank'); 
  }

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col pt-6 pb-12 px-4 selection:bg-rose-200">
      <div className="w-full max-w-md mx-auto bg-white rounded-3xl shadow-xl overflow-hidden border border-gray-100">
        
        {/* Header */}
        <div className="bg-gradient-to-r from-rose-500 to-pink-500 p-6 text-white text-center relative">
          <button 
           onClick={() => navigate('/')} 
           className="absolute left-4 top-6 p-2 bg-white/20 hover:bg-white/30 rounded-full transition-colors flex items-center justify-center">
            <ChevronLeft size={20} />
          </button>
          <div className="mx-auto bg-white/20 w-16 h-16 rounded-full flex items-center justify-center mb-4">
            <Calculator size={32} className="text-white" />
          </div>
          <h1 className="text-2xl font-bold">Fiyat Hesapla</h1>
          <p className="text-white/80 mt-1 text-sm">Hızlıca kart maliyetinizi görün</p>
        </div>

        {/* Content */}
        <div className="p-6 space-y-8">
          
          {/* Sabit Ücret */}
          <div className="space-y-4">
            <div className="flex justify-between items-center">
              <div>
                <h3 className="font-semibold text-gray-800 text-lg">Sistem Ücreti</h3>
                <p className="text-xs text-gray-500">Kişisel içerik sayfanızın ve karekodunuzun oluşturulması</p>
              </div>
              <div className="bg-rose-50 text-rose-600 px-3 py-1 rounded-lg font-bold shadow-sm">
                {baseFee} TL
              </div>
            </div>
          </div>

          <hr className="border-rose-100/50" />

          {/* Masa Kartı */}
          <div className="space-y-4">
            <div className="flex justify-between items-start">
              <div>
                <h3 className="font-semibold text-gray-800 text-lg">Masa Kartı <br/><span className="text-sm font-normal text-gray-500">(15 TL/Adet)</span></h3>
                <p className="text-xs text-gray-500 mt-1">Masaların üzerindeki QR kartlar</p>
              </div>
              <div className="bg-rose-50 text-rose-600 px-3 py-1 rounded-lg font-bold shadow-sm whitespace-nowrap">
                {tableCardTotal} TL
              </div>
            </div>
            <input 
              type="range" 
              min="0" 
              max="500" 
              step="10"
              value={tableCards} 
              onChange={(e) => setTableCards(Number(e.target.value))}
              className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-rose-500"
            />
            <div className="flex justify-between flex-wrap items-center text-sm text-gray-400 mt-2">
              <span>0</span>
              <div className="flex items-center gap-2">
                <input 
                  type="number" 
                  min="0"
                  max="1000"
                  value={tableCards === 0 ? '' : tableCards}
                  onChange={(e) => setTableCards(Number(e.target.value) || 0)}
                  className="w-20 px-2 py-1 text-center font-bold text-rose-700 bg-rose-50 border border-rose-200 rounded-md focus:outline-none focus:ring-2 focus:ring-rose-500"
                />
                <span className="font-semibold text-rose-600">Adet</span>
              </div>
              <span>500+</span>
            </div>
          </div>

          <hr className="border-rose-100/50" />

          {/* El Kartı */}
          <div className="space-y-4">
            <div className="flex justify-between items-center">
              <div>
                <h3 className="font-semibold text-gray-800 text-lg">El Kartı <span className="text-sm font-normal text-gray-500">({handCardPrice} TL/Adet)</span></h3>
                <p className="text-xs text-gray-500">Misafirlere dağıtılan ufak kartlar</p>
              </div>
              <div className="bg-rose-50 text-rose-600 px-3 py-1 rounded-lg font-bold shadow-sm whitespace-nowrap">
                {handCardTotal} TL
              </div>
            </div>
            <input 
              type="range" 
              min="0" 
              max="500" 
              step="10"
              value={handCards} 
              onChange={(e) => setHandCards(Number(e.target.value))}
              className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-rose-500"
            />
            <div className="flex justify-between flex-wrap items-center text-sm text-gray-400 mt-2">
              <span>0</span>
              <div className="flex items-center gap-2">
                <input 
                  type="number" 
                  min="0"
                  max="1000"
                  value={handCards === 0 ? '' : handCards}
                  onChange={(e) => setHandCards(Number(e.target.value) || 0)}
                  className="w-20 px-2 py-1 text-center font-bold text-rose-700 bg-rose-50 border border-rose-200 rounded-md focus:outline-none focus:ring-2 focus:ring-rose-500"
                />
                <span className="font-semibold text-rose-600">Adet</span>
              </div>
              <span>500+</span>
            </div>
          </div>

          <hr className="border-rose-100/50" />

          {/* Karşılama Panosu */}
          <div className="space-y-4">
            <div className="flex justify-between items-center">
              <div>
                <h3 className="font-semibold text-gray-800 text-lg">Karşılama Panosu <span className="text-sm font-normal text-gray-500">({boardPrice} TL/Adet)</span></h3>
                <p className="text-xs text-gray-500">Düğün girişi için büyük QR pano</p>
              </div>
              <div className="bg-rose-50 text-rose-600 px-3 py-1 rounded-lg font-bold shadow-sm whitespace-nowrap">
                {boardTotal} TL
              </div>
            </div>
            <input 
              type="range" 
              min="0" 
              max="50" 
              step="1"
              value={boardCards} 
              onChange={(e) => setBoardCards(Number(e.target.value))}
              className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-rose-500"
            />
            <div className="flex justify-between flex-wrap items-center text-sm text-gray-400 mt-2">
              <span>0</span>
              <div className="flex items-center gap-2">
                <input 
                  type="number" 
                  min="0"
                  max="100"
                  value={boardCards === 0 ? '' : boardCards}
                  onChange={(e) => setBoardCards(Number(e.target.value) || 0)}
                  className="w-20 px-2 py-1 text-center font-bold text-rose-700 bg-rose-50 border border-rose-200 rounded-md focus:outline-none focus:ring-2 focus:ring-rose-500"
                />
                <span className="font-semibold text-rose-600">Adet</span>
              </div>
              <span>50+</span>
            </div>
          </div>

          <hr className="border-rose-100/50" />

          {/* AI Enhance */}
          <div className="space-y-4">
            <div className="flex justify-between items-center">
              <div>
                <h3 className="font-semibold text-gray-800 text-lg">Yapay Zeka İyileştirme <span className="text-sm font-normal text-gray-500">({aiEnhancePrice} TL/Adet)</span></h3>
                <p className="text-xs text-gray-500">Karanlık, kumlu ve bulanık fotoğrafları netleştirme</p>
              </div>
              <div className="bg-rose-50 text-rose-600 px-3 py-1 rounded-lg font-bold shadow-sm whitespace-nowrap">
                {aiEnhanceTotal} TL
              </div>
            </div>
            <input 
              type="range" 
              min="0" 
              max="500" 
              step="10"
              value={aiEnhance} 
              onChange={(e) => setAiEnhance(Number(e.target.value))}
              className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-rose-500"
            />
            <div className="flex justify-between flex-wrap items-center text-sm text-gray-400 mt-2">
              <span>0</span>
              <div className="flex items-center gap-2">
                <input 
                  type="number" 
                  min="0"
                  max="1000"
                  value={aiEnhance === 0 ? '' : aiEnhance}
                  onChange={(e) => setAiEnhance(Number(e.target.value) || 0)}
                  className="w-20 px-2 py-1 text-center font-bold text-rose-700 bg-rose-50 border border-rose-200 rounded-md focus:outline-none focus:ring-2 focus:ring-rose-500"
                />
                <span className="font-semibold text-rose-600">Adet</span>
              </div>
              <span>500+</span>
            </div>
          </div>

          <hr className="border-rose-100/50" />

          {/* AI Artistic */}
          <div className="space-y-4">
            <div className="flex justify-between items-center">
              <div>
                <h3 className="font-semibold text-gray-800 text-lg">AI Sanatsal Filtre <span className="text-sm font-normal text-gray-500">({aiArtisticPrice} TL/Adet)</span></h3>
                <p className="text-xs text-gray-500">Fotoğrafları karikatür, yağlı boya vb. tarzlara dönüştürme</p>
              </div>
              <div className="bg-rose-50 text-rose-600 px-3 py-1 rounded-lg font-bold shadow-sm whitespace-nowrap">
                {aiArtisticTotal} TL
              </div>
            </div>
            <input 
              type="range" 
              min="0" 
              max="100" 
              step="5"
              value={aiArtistic} 
              onChange={(e) => setAiArtistic(Number(e.target.value))}
              className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer accent-rose-500"
            />
            <div className="flex justify-between flex-wrap items-center text-sm text-gray-400 mt-2">
              <span>0</span>
              <div className="flex items-center gap-2">
                <input 
                  type="number" 
                  min="0"
                  max="200"
                  value={aiArtistic === 0 ? '' : aiArtistic}
                  onChange={(e) => setAiArtistic(Number(e.target.value) || 0)}
                  className="w-20 px-2 py-1 text-center font-bold text-rose-700 bg-rose-50 border border-rose-200 rounded-md focus:outline-none focus:ring-2 focus:ring-rose-500"
                />
                <span className="font-semibold text-rose-600">Adet</span>
              </div>
              <span>100+</span>
            </div>
          </div>

          {/* Toplam */}
          <div className="bg-gray-50 -mx-6 p-6 mt-6 border-t border-gray-100">
            <div className="flex justify-between items-end mb-6">
              <span className="text-gray-500 font-medium">Genel Toplam:</span>
              <span className="text-4xl font-extrabold text-gray-800">{total} <span className="text-xl text-gray-500 font-semibold tracking-wide">TL</span></span>
            </div>
            
            <div className="space-y-3">
              <button 
                onClick={() => navigate('/paketler')}
                className="w-full bg-rose-500 hover:bg-rose-600 text-white font-semibold py-3 px-4 rounded-xl flex items-center justify-center gap-2 transition-all shadow-lg shadow-rose-500/30 active:scale-[0.98]">
                <ShoppingBag size={20} />
                Siparişe Başla
              </button>
              <button 
                onClick={handleWhatsapp}
                className="w-full bg-white hover:bg-gray-50 text-gray-700 font-semibold py-3 px-4 rounded-xl flex items-center justify-center gap-2 transition-all border border-gray-200 shadow-sm active:scale-[0.98]">
                <MessageCircle size={20} className="text-green-500" />
                Bizimle İletişime Geçin
              </button>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default CalculatorPage;
